var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.723,
    height: 20.246,
    viewBox: "0 0 20.723 20.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Icon_awesome-facebook-square",
    "data-name": "Icon awesome-facebook-square",
    d: "M16.717,2.25H2.006A1.981,1.981,0,0,0,0,4.2V18.541A1.981,1.981,0,0,0,2.006,20.5H7.742v-6.2H5.109v-2.92H7.742V9.148a3.609,3.609,0,0,1,3.915-3.929,16.355,16.355,0,0,1,2.32.2V7.9H12.67a1.479,1.479,0,0,0-1.689,1.577v1.9h2.874l-.46,2.92H10.981v6.2h5.736a1.981,1.981,0,0,0,2.006-1.955V4.2A1.981,1.981,0,0,0,16.717,2.25Z",
    transform: "translate(1 -1.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.8252a277705b953be8e30211992c51a6.svg";
export { ForwardRef as ReactComponent };